import {Inject, Injectable} from "@angular/core";
import {WINDOW_REF_TOKEN} from "../../tokens";
import {INT_STORAGE_TYPE_TOKEN} from "./int-storage-type.token";
import {TIntStorageType} from "../../types";

@Injectable({providedIn: 'root'})
export class IntStorageService {
  constructor(
    @Inject(INT_STORAGE_TYPE_TOKEN) private storageType: TIntStorageType,
    @Inject(WINDOW_REF_TOKEN) private readonly windowRef: Window
  ) {
  }

  setStorageTypeHandle(storageType: TIntStorageType) {
    this.storageType = storageType;
  }

  set(key: string, value: unknown) {
    const _value = (typeof value === 'string' || value === null) ? `${value}` : JSON.stringify(value);
    this.windowRef[this.storageType].setItem(key, _value)
  }

  get(key: string) {
    return this.windowRef[this.storageType].getItem(key);
  }

  has(key: string): boolean {
    return !!this.get(key);
  }

  getWithParse<T>(key: string): T | null {
    try {
      const data = this.windowRef[this.storageType].getItem(key);
      if(data !== null && data !== undefined) {
        const withParse: T = JSON.parse(data);
        return withParse;
      }else{
        return null;
      }
    }catch (err) {
      return null
    }
  }
  clear(key: string) {
    this.windowRef[this.storageType].removeItem(key);
  }
}
